"use strict";

exports.__esModule = true;
var _SSRProviderModule = require("./SSRProvider.module.js");
exports.SSRProvider = _SSRProviderModule.SSRProvider;
exports.useIsSSR = _SSRProviderModule.useIsSSR;
exports.useSSRSafeId = _SSRProviderModule.useSSRSafeId;